import { defineStore } from "pinia";
import {
  IPrintRecord,
  PrintPage,
  PrintRecord,
  PrintSection,
  PrintSlices,
} from "@/types/print";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

interface VisiblePage {
  sections: PrintSection[];
}

interface PrinterState {
  isReady: boolean;
  logoCanvas: boolean;
  records: PrintRecord[];
  printMessage: string;
  sections: PrintSection[];
  pages: PrintPage[];
  currentPageIndex: number;
  position: number;
  downloaded: boolean;
  doc: null | jsPDF;
  visiblePages: VisiblePage[];
}

export const usePrinter = defineStore("printer", {
  state: (): PrinterState => ({
    isReady: false,
    logoCanvas: true,
    records: [],
    printMessage: "Starting print service...",
    sections: [],
    pages: [],
    currentPageIndex: 0,
    position: 0,
    downloaded: false,
    doc: null as null | jsPDF,
    visiblePages: [],
  }),
  actions: {
    addRecord(record: PrintRecord) {
      this.records = [...this.records, record];
    },
    reset() {
      this.records = [];
      this.printMessage = "Starting print service...";
    },
    async queueRecords(records: IPrintRecord[], index = 0): Promise<any> {
      this.printMessage =
        index === records.length
          ? "Generating preview..."
          : "Printing " + records[index]?.name + "...";
      return index === records.length
        ? Promise.resolve().then(() => {
            setTimeout(() => {
              this.printMessage = "Starting print service...";
            }, 1e3);
          })
        : this.createCanvas(records[index]).then((canvas) => {
            this.addRecord(
              new PrintRecord({
                ...records[index],
                canvas,
                slices: new PrintSlices(records[index]),
              })
            );
            return this.queueRecords(records, index + 1);
          });
    },
    async createCanvas(record: IPrintRecord) {
      return html2canvas(record.$el, {
        scale: record.scale,
        allowTaint: true,
        logging: true,
        windowHeight: 850,
        windowWidth: 1920,
      });
    },
  },
});
